import generateBasicEntityActions from "./generateBasicEntityActions";
import * as schemas from "../schemas";

const basicEntityActions = generateBasicEntityActions("myFiSwapSuggestions");
const myFiSwapSuggestionActions = {
  ...basicEntityActions,
};

export default myFiSwapSuggestionActions;
